import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.25rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção 4 · Quando é exigível (fundo claro)
const CONTEXTS = [
  'Partilha com tornas entre herdeiros.',
  'Inventário, judicial ou notarial, com desacordo sobre valores.',
  'Cessão de quota hereditária entre herdeiros.',
  'Venda de imóvel da herança, para fixar o preço.',
  'Financiamento pedido por um herdeiro para pagar tornas.'
];

export const ApplicabilitySection = () => (
  <section
    className="valuare-section"
    data-testid="herancas-applicability-section"
  >
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">Quando faz diferença</div>
        <h2 className="valuare-section-title">
          Cinco<br />
          situações <em>concretas</em>
        </h2>
        {CONTEXTS.map((text, i) => (
          <p key={i} style={i === CONTEXTS.length - 1 ? { ...P, marginBottom: 0 } : P}>
            {text}
          </p>
        ))}
      </div>
    </div>
  </section>
);
